module.exports = __webpack_public_path__ + "static/media/Poppins-Light.cee99a1a.woff2";